'use client';

import { Container } from '@/app/components/layouts/container';
import { Item } from '@/app/components/layouts/top-navigation/buying-tools/item';
import { TOP_NAV_DATA_TEST } from '@/app/components/layouts/top-navigation/tracking';
import { MENU_LINK_CV, MENU_LINK_LCV } from '@/app/contents/top-navigation';
import type { MenuLinkType } from '@/app/types/top-navigation';
import { VehicleType } from '@/app/types/vehicle-type';
import { createDataAttributes } from '@/app/utils/createDataAttributes';

interface BuyingToolsProps {
  vehicleType: VehicleType;
  items: MenuLinkType[];
}

export const BuyingTools = ({ vehicleType, items = [] }: BuyingToolsProps) => {
  return (
    <aside
      className="relative z-40 hidden bg-gray-800 xl:block"
      {...createDataAttributes({
        test: TOP_NAV_DATA_TEST.buyingToolsNavigation,
      })}
      data-myi-hide
    >
      <Container
        as="nav"
        role="menubar"
        aria-label="Buying tools navigation"
        size="desktop-only"
        className="text-body-2-fixed flex h-10 justify-between gap-4 text-white"
      >
        <div className="flex items-center gap-x-4">
          <Item {...MENU_LINK_LCV} isActiveVehicle={vehicleType === 'lcv'} />
          <Item {...MENU_LINK_CV} isActiveVehicle={vehicleType === 'cv'} />
        </div>
        <div className="flex items-center gap-x-4">
          {items.map((item, index) => (
            <Item key={`buying_nav_${index}`} {...item} />
          ))}
        </div>
      </Container>
    </aside>
  );
};
